// src/icons/index.js
import React from 'react';

export const DashboardIcon = () => (
  <i className="bi bi-speedometer2"></i>
);

export const LibraryIcon = () => (
  <i className="bi bi-book"></i>
);

export const ChatbotIcon = () => (
  <i className="bi bi-robot"></i>
);

export const AdminIcon = () => (
  <i className="bi bi-gear"></i>
);

export const IncidentIcon = () => (
  <i className="bi bi-exclamation-triangle"></i>
);

export const DocumentIcon = () => (
  <i className="bi bi-file-earmark"></i>
);

export const FolderIcon = () => (
  <i className="bi bi-folder"></i>
);

export const FileTextIcon = () => (
  <i className="bi bi-file-earmark-text"></i>
);

export const UserIcon = () => (
  <i className="bi bi-person"></i>
);

export const ShieldIcon = () => (
  <i className="bi bi-shield-lock"></i>
);

export const BellIcon = () => (
  <i className="bi bi-bell"></i>
);

export const KeyIcon = () => (
  <i className="bi bi-key"></i>
);

export { default as MapIcon } from './MapIcon';